import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useStorefrontTenant } from "context/StorefrontTenantContext";
import { resolveStorefrontPage } from "./registry";

function StorefrontPageMissing({ page, tenantKey }) {
  return (
    <Box
      minHeight="40vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={2}
      sx={{ color: "#55575C", fontWeight: 600 }}
    >
      Storefront page &quot;{page}&quot; is not configured
      {tenantKey ? ` for ${tenantKey}` : ""}.
    </Box>
  );
}

StorefrontPageMissing.propTypes = {
  page: PropTypes.string.isRequired,
  tenantKey: PropTypes.string,
};

StorefrontPageMissing.defaultProps = {
  tenantKey: "",
};

/**
 * Renders the tenant-specific storefront page when registered, otherwise shared default.
 */
export default function StorefrontPage({ page }) {
  const { tenantKey } = useStorefrontTenant();
  const PageComponent = resolveStorefrontPage(tenantKey, page);

  if (!PageComponent) {
    return <StorefrontPageMissing page={page} tenantKey={tenantKey} />;
  }

  return <PageComponent />;
}

StorefrontPage.propTypes = {
  page: PropTypes.oneOf([
    "home",
    "catalog",
    "productDetail",
    "cart",
    "checkout",
    "signIn",
    "layout",
    "portalLayout",
  ]).isRequired,
};
